import React, { useContext } from 'react';
import ShopifyImage from './ShopifyImage';
import { PracticeJerseyOrderContext } from './PracticeJerseyBuilder';


const ShopifyProduct = ({ product, handleSelectProduct }) => {
    const { sizeData } = useContext(PracticeJerseyOrderContext);
    return (
        <div className="product-option" onClick={() => handleSelectProduct(product)}>
            {product.images.length >= 0 && <ShopifyImage image={product?.images[0]} />}
            <h2 className="Heading">{product.title}</h2>
        </div>
    )
}

export default ShopifyProduct